import React from 'react';

/** */
export function SignupSuccess() {
  return <div>account created successfully</div>;
}
